import actionTypes from '../constants/action-types';

const connectMappedHTML = (mappedHTML) => ({
  type: actionTypes.CONNECT_MAPPED_HTML,
  payload: {
    mappedHTML,
  },
});

export default connectMappedHTML;
